/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-18 17:00:03
 * @LastEditors: hai.yang3 hai.yang3@gientech.com
 * @LastEditTime: 2022-08-19 16:49:45
 * @FilePath: \unified-development-platform\src\apis\auth\move-auth\user_manage_api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { request } from '@/apis/request';
const PRE_PATH = '/v1/sys';
export const get_users = params => {
  return request({
    url: `${PRE_PATH}/sysUser/list`,
    method: 'get',
    params: params,
    rd: true,
  });
};
export const get_staffs = params => {
  return request({
    url: `${PRE_PATH}/staff`,
    method: 'get',
    params: params,
    rd: true,
  });
};
export const check_user_name = userName => {
  return `${PRE_PATH}/sysUser/duplicates?userName=${userName}`;
};
export const get_orgs_by_user_no = userNo => {
  return request({
    url: `${PRE_PATH}/sysUser/roleAndOrgs/${userNo}`,
    method: 'get',
    rd: true,
  });
};
export const delete_user = userNo => {
  return request({
    url: `${PRE_PATH}/sysUser/delete?userNo=${userNo}`,
    method: 'get',
    rd: true,
  });
};
export const update_user = params => {
  return request({
    url: `${PRE_PATH}/sysUser/save`,
    method: 'post',
    data: params,
    rd: true,
  });
};
export const update_user_password = (oldPassword, newPassword) => {
  // return http.post(
  //   `sysUser/updatePwd`,
  //   {
  //     oldPassword: window.sha1(oldPassword),
  //     newPassword: window.sha1(newPassword)
  //   }
  // );
  //   return request({
  //     url: `${PRE_PATH}/sysUser/updatePwd`,
  //     method: 'post',
  //     data: {
  //       oldPassword: window.sha1(oldPassword),
  //       newPassword: window.sha1(newPassword)
  //     },
  // })
};
export const get_all_enable_users = params => {
  return request({
    url: `${PRE_PATH}/sysUser/all`,
    method: 'get',
    params: params,
    rd: true,
  });
};
export const get_user_info = () => {
  return request({
    url: `${PRE_PATH}/sysUser/userInfo`,
    method: 'post',
    rd: true,
  });
};
